import { useAppDispatch } from "../../redux";
import type { IReactionsProps } from "../../types";
import { setError, setSuccess } from "../../AppSlice";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";

export default function _Reactions(props: IReactionsProps) {
  const { error, success, isLoading } = props;

  const dispatch = useAppDispatch();

  const handleClearError = () => dispatch(setError(null));

  const handleClearSuccess = () => dispatch(setSuccess(null));

  return (
    <>
      <Backdrop open={isLoading} sx={{ zIndex: 1301 }}>
        <CircularProgress sx={{ color: "#fff" }} id="loading" />
      </Backdrop>

      <Snackbar
        open={!!error || !!success}
        autoHideDuration={5000}
        onClose={error ? handleClearError : handleClearSuccess}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{ zIndex: 1302 }}
      >
        {error ? (
          <Alert severity="error" onClose={handleClearError} sx={{ padding: "20px" }}>
            {error}
          </Alert>
        ) : success ? (
          <Alert severity="success" onClose={handleClearSuccess} sx={{ padding: "20px" }}>
            {success}
          </Alert>
        ) : (
          <div />
        )}
      </Snackbar>
    </>
  );
}
